import {form} from "@reown/appkit/networks";

export const getInfluencerTags = (startIndex, limit) => {
    const params = new URLSearchParams();

    params.append("limit", limit);
    params.append("start_index", startIndex);

    const url = `https://crowdwisdom.live/wp-json/api/v1/getAllInfluencer/?${params}`;

    return fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
    })
    .then((response) => {
        if (!response.ok) {
            throw new Error("Error while fetching data");
        }
        return response.json();
    })
    .catch((error) => {
        console.error("Error:", error);
        return {code: "500", message: "Internal Server Error"};
    });
};

export const addInfluencer = async (
    creatorName,
    description,
    creatorImage,
    youtubeLink,
    xLink,
    telegramLink,
    instagramLink,
    user_id
) => {
    const formData = new FormData();
    formData.append("creatorName", creatorName);
    formData.append("description", description);
    formData.append("creatorImage", creatorImage);
    formData.append("youtube", youtubeLink);
    formData.append("x", xLink);
    formData.append("telegram", telegramLink);
    formData.append("instagram", instagramLink);
    formData.append("user_id", user_id);

    try {
        const response = await fetch("https://crowdwisdom.live/wp-json/api/v1/add_creator", {
            method: "POST",
            body: formData,
        });

        const result = await response.json();

        // Return the error message received from backend
        return result;
        // Optional: reset state or show success message
    } catch (error) {
        return {
            success: false,
            message: error.message || "Something went wrong while submitting",
        };
    }
};


export const addToPortfolioDao = (data) => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", data.Token);
    // myHeaders.append("Token",data.Token);
    // const today = new Date();

    // const month = data.date_time.getMonth()+1;
    // const year = data.date_time.getFullYear();
    // const date = data.date_time. getDate();
    // const currentDate = month + "/" + date + "/" + year;
    // handleDateChange(month + "/" + date + "/" + year)
    var raw = JSON.stringify({
        portfolio_type_id: data.portfolio_type_id,
        portfolio_name: data.portfolio_name,
        existing_portfolio: data.existing_portfolio,
        user_id: data.user_id,
        slug: data.slug,
        unit: data.unit,
        acquisition_price: data.acquisition_price,
        date_time: data.date_time,
        type: data.type,
        ref_link: data.refLink,
        tagged_influencer: data.tagged_influencer
    });
    var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
    };

    return fetch(`https://crowdwisdom.live/wp-json/portfolio/v1/updatetoportfolioForDAO`, requestOptions)
    .then((response) => response.json())
    .catch((error) => console.log("error", error));
};


export const getPendingPortfolio = (user_id) => {
    const params = new URLSearchParams({ user_id });

    return fetch(`https://crowdwisdom.live/wp-json/portfolio/v1/get_tagged_pending_portfolio?${params.toString()}`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json", // Not strictly required for GET but clearer
        },
    })
        .then((response) => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
        })
        .catch((error) => {
            console.error("Error:", error);
            return { code: "500", message: "Internal Server Error" };
        });
};


export const addInfluencerVoting = async(data) => {

     const myHeaders = new Headers({
        "Content-Type": "application/json",
        "Authorization": data.token,
    });

    const requestOptions = {
        method: "POST",
        headers: myHeaders,
        redirect: "follow",
        body: JSON.stringify({
            user_id: data.user_id,
            portfolio_id: data.portfolio_id,
            action : data.action
        }),
    };

    try {
        const response = await fetch(
            `https://crowdwisdom.live/wp-json/portfolio/v1/add_influencer_voting`,
            requestOptions
        );

        const result = await response.json();

        if (!response.ok) {
            throw new Error(result.message || "Failed to withdraw rewards.");
        }

        return result;
    } catch (error) {
        throw error; // Let caller handle the message
    }
};
